import request from '../helpers/request';
import { AuthHeader } from '../helpers';

export {
  createCustomer,
  getCustomers,
  updateCustomerPrices,
  getCustomerById,
  updateCustomer,
  getCustomerPrices,
  deleteCustomerById
};

function createCustomer(
  fullName,
  customerName,
  address,
  city,
  postal,
  email,
  phone,
) {
  return request({
    url: 'customers/create',
    method: 'POST',
    data: {
      name: customerName,
      contact: fullName,
      address: address,
      city: city,
      postal: postal,
      email: email,
      phone: phone,
    },
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function updateCustomer(
  fullName,
  customerName,
  address,
  city,
  postal,
  email,
  phone,
  customerId,
) {
  return request({
    url: 'customers/update/' + customerId,
    method: 'PUT',
    data: {
      name: customerName,
      contact: fullName,
      address: address,
      city: city,
      postal: postal,
      email: email,
      phone: phone,
    },
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function updateCustomerPrices(customerId, categories) {
  return request({
    url: 'customers/' + customerId + '/prices',
    method: 'POST',
    data: {
      categories: categories,
    },
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getCustomerPrices(customerId) {
  return request({
    url: 'customers/' + customerId + '/prices',
    method: 'GET',
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getCustomers() {
  return request({
    url: 'customers/',
    method: 'GET',
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getCustomerById(customerId) {
  return request({
    url: 'customers/' + customerId,
    method: 'GET',
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function deleteCustomerById(customerId) {
  return request({
    url: `customers/${customerId}`,
    method: 'DELETE',
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}
